// /leverage → the v3 Leverage Desk (2× single-stock ETFs on Atlas names),
// reached from the More sheet. Thin shim like the other v2/pages screens.
import { LeverageDesk } from '@/v2/v3/LeverageDesk'

export function V2LeveragePage() {
  return <LeverageDesk />
}
